export default function MyQueue(){
    this._queue = [];
    this._handler = null;
    this._delayers = [];
}

MyQueue.prototype.push = function(that , fn , params, sec){
    !that && (that = this);
    let item = {
        that:that,
        fn:fn,
        params:params,
        sec:sec
    }
    this._queue.push(item);
    this._start();
}

MyQueue.prototype.unshift = function(that , fn , params, sec){
    !that && (that = this);
    let item = {
        that:that,
        fn:fn,
        params:params,
        sec:sec
    }
    this._queue.unshift(item);
    this._start();
}

MyQueue.prototype.clear = function(){
    if (this._handler) {
        clearTimeout(this._handler);
    }
    this._handler = null;
    while(this._queue.length > 0) {
        this._queue.shift();
    }
    while(this._delayers.length > 0) {
        let item = this._delayers.shift();
        if (item.handler) {
            clearTimeout(item.handler);
            item.handler = null;
        }
        item = null;
    }    
}

MyQueue.prototype._start = function(){
    if (!this._handler) {
        this._action();
    }
}

MyQueue.prototype._action = function(){
    if (this._handler) {
        clearTimeout(this._handler);
    }
    this._handler = null;
    if (this._queue.length > 0) {
        let item = this._queue.shift();
        this._handler = setTimeout(() => {
            item.fn.apply(item.that , item.params);
            this._action();
        }, item.sec);
    }
}

MyQueue.prototype.setDelayer = function(that , fn , params, sec){
    !that && (that = this);
    var item = {
        that:that,
        fn:fn,
        params:params,
        sec:sec,
    }
    item.handler = setTimeout(() => {
        item.fn.apply(item.that , item.params);
    }, item.sec);
    this._delayers.push(item);
}




// WEBPACK FOOTER //
// ./src/utils/queue.js